export default "__VITE_ASSET__DBdNg8Dj__"